import componentFn from '../../styles/objects/component'
import { important } from '../../styles/tools/parsers'

export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes,
  textTransforms
}) => {
  const component = componentFn({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
  })

  const styles = {
    globals: {
      '*.react-datepicker': {
        fontFamily: fontFamilies.default,
        fontWeight: fontWeights.datepicker.default
      },
      '*.react-datepicker__triangle': {
        borderBottomColor: important(colors.datepicker.header.bg),
        '::before': {
          borderBottomColor: important(colors.datepicker.header.bg)
        }
      },
      '*.react-datepicker__month-container': {
        borderRadius: '4px',
        backgroundColor: important(colors.datepicker.header.bg)
      },
      '*.react-datepicker__year-read-view--selected-year': {
        color: important(colors.datepicker.header.text)
      },
      '*.react-datepicker__day-name': {
        color: important(colors.datepicker.header.text)
      },
      '*.react-datepicker__month': {
        margin: '0',
        padding: '.4rem',

        backgroundColor: important(colors.datepicker.header.text)
      },
      '*.react-datepicker__current-month': {
        textTransform: 'capitalize',

        color: important(colors.datepicker.header.text)
      },
      '*.react-datepicker__navigation--next': {
        borderLeftColor: important(colors.datepicker.header.text),
        ':hover': {
          borderLeftColor: important(colors.datepicker.arrow)
        }
      },
      '*.react-datepicker__navigation--previous': {
        borderRightColor: important(colors.datepicker.header.text),
        ':hover': {
          borderRightColor: important(colors.datepicker.arrow)
        }
      },
      '*.react-datepicker__year-read-view--down-arrow': {
        borderWidth: '.2rem',
        borderTopColor: important(colors.datepicker.header.text),
        ':hover': {
          borderTopColor: important(colors.datepicker.arrow)
        },
        '::before': {
          borderWidth: '.2rem',
          borderTopColor: important(colors.datepicker.header.text),
          ':hover': {
            borderTopColor: important(colors.datepicker.arrow)
          }
        }
      },
      '*.react-datepicker__year-read-view--down-arrow':{
        marginLeft:'35px'
      },
      '*.react-datepicker__year-read-view--selected-year':{
        marginRight:'15px'
      },
      '*.react-datepicker__month-read-view--down-arrow':{
        marginLeft:'35px'
      },
      '*.react-datepicker__month-read-view--selected-month':{
        marginRight:'20px'
      },
      '*.react-datepicker__header': {
        borderBottom: `1px solid ${important(colors.datepicker.header.bg)}`,
        backgroundColor: important(colors.datepicker.header.bg)
      },
      '*.react-datepicker-wrapper': {
        width: '100%'
      },
      '*.react-datepicker__input-container': {
        width: '100%'
      },
      // '*.react-datepicker__tether-element': {
      //   display: 'none'
      // },
      '*.react-datepicker__day': {
        color: important(colors.datepicker.day.text.default),
        ':hover': {
          borderRadius: '100%',
          color: important(colors.datepicker.day.text.default),
          backgroundColor: important(colors.datepicker.day.bg.hover)
        }
      },
      '*.react-datepicker__day--selected': {
        backgroundColor: important(colors.datepicker.day.bg.selected),
        color: important(colors.datepicker.day.text.selected),
        borderRadius: '100%',
        ':hover': {
          color: important(colors.datepicker.day.text.hover),
          borderRadius: '100%',
          backgroundColor: important(colors.datepicker.day.bg.hover)
        }
      },
      '*.react-datepicker__day--keyboard-selected': {
        backgroundColor: important(colors.datepicker.day.bg.keyboard),
        color: important(colors.datepicker.day.text.keyboard),
        borderRadius: '100%',
        ':hover': {
          color: important(colors.datepicker.day.text.hover)
        }
      }
    },
    'hide-datepicker':{
      opacity:'0'
    }
  }

  return { ...component, ...styles }
}



// WEBPACK FOOTER //
// ./components/datepicker/styles.js